import { asApr } from "@silo/utils";
import { match } from "ts-pattern";
import { BorrowState, Reward } from "./types";
import { classNames } from "../../utils/class-names";

export interface BorrowAprBreakdownProps {
  borrowApr: bigint;
  borrowState: BorrowState;
  rewards: Reward[];
  variant: "market" | "asset";
}

export function BorrowAprBreakdown({
  borrowApr,
  borrowState,
  variant,
  rewards,
}: BorrowAprBreakdownProps): JSX.Element {
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex flex-col gap-2.5">
        <BorrowBaseApr borrowApr={borrowApr} />

        {rewards.map((reward, i) => (
          <BorrowRewardApr key={i} reward={reward} />
        ))}
      </div>

      {borrowState === "netYield" && (
        <div
          className={classNames(
            "rounded-lg bg-green-400/10 p-2.5 text-green-400 font-medium",
            match(variant)
              .with("market", () => "")
              .with("asset", () => "text-sm")
              .exhaustive()
          )}
        >
          You make a positive yield on borrowing
        </div>
      )}
    </div>
  );
}

interface BorrowBaseAprProps {
  borrowApr: bigint;
  className?: string;
}

export function BorrowBaseApr({ borrowApr, className }: BorrowBaseAprProps) {
  return (
    <div
      className={classNames(
        "flex items-center gap-2.5 text-shale-200",
        className
      )}
    >
      <span className="font-mono font-medium text-red-400">
        {asApr(borrowApr)}
      </span>{" "}
      <span>borrow APR (cost)</span>
    </div>
  );
}

interface BorrowRewardAprProps {
  reward: Reward;
  className?: string;
}

export function BorrowRewardApr({ reward, className }: BorrowRewardAprProps) {
  const { apr, symbol } = reward;

  return (
    <div
      className={classNames(
        "flex items-center gap-2.5 text-shale-200",
        className
      )}
    >
      <span className="font-mono font-medium text-white">{asApr(apr)}</span>

      <span>rewards APR in {symbol} (yield)</span>
    </div>
  );
}
